import * as swcHelpers from '@swc/helpers';
import { okOrThrow } from '../../response.js';
import { acceptJson, postJson, authHeader } from '../../shared.js';

function pause(apiUrl, accessToken, customerId, subscriptionId, request) {
    return _pause.apply(this, arguments);
}
function _pause() {
    _pause = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, customerId, subscriptionId, request) {
        return okOrThrow((yield fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/subscription/${subscriptionId}/pause`, {
            method: 'POST',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson, authHeader(accessToken)),
            body: JSON.stringify(request)
        })));
    });
    return _pause.apply(this, arguments);
}

export { pause };
//# sourceMappingURL=pause.js.map
